import alertify from "alertifyjs";
import {initResizableTable} from '@newgen/flex-table/dist/resizable-columns.js';
import {initTableWithToggleableColumns} from '@newgen/flex-table/dist/toggleable-columns.js';
import {initTableWithScrollableCells} from "../table/scrollable-cell.ts";
import {initTableWithDivider} from "../table/rows-divider.ts"

export const ready_admin = function ($element) {
  $element = $($element);
  $element.find("[clipboard]").on("click", function (event) {
    let $target = $(this).attr("clipboard");
    $($target).trigger("select");

    try {
      let successful = document.execCommand("copy");
      let msg = successful ? "successful" : "unsuccessful";
      console.log("Copying text command was " + msg);
    } catch (err) {
      console.log("Oops, unable to copy");
    }
  });

  $element
    .find(".grid-view")
    .find("[img-preview]")
    .on({
      mouseenter: function () {
        let $src = $(this).attr("img-preview");
        let $img = $("<img/>").attr({ src: $src });
        $("<div/>")
          .attr({ class: "thu_preview", style: `transform: translateY(-${window.pageYOffset}px)` })
          .append($img)
          .insertAfter(this);
      },
      mouseleave: function () {
        $(this).next().remove();
      },
    });

  $element
    .find(".elastic")
    .on("keyup paste change keydown ajaxComplete", function () {
      $(this).elastic();
    })
    .trigger("change");

  $element.find(".extra-btn").on("click", function () {
    $(this).hide().parents("form").find(".extra-field").show();
  });

  $element.find(".extra-btn-reverse").on("click", function () {
    $(this).parents("form").find(".extra-field").slideToggle("fast");
    $(this).find("i").toggleClass("fa-d fa-angle-double-up");
  });

  $element.find(".row-parent .row-btn").on("click", function () {
    let $this = $(this);
    let $row = $this.parents(".row-parent").toggleClass("active");
    let id = $this.attr("model-id");
    let model_url = $this.attr("model-url");
    if ($row.hasClass("active")) {
      let $td = $("<td></td>").attr("colspan", "100%");
      $("<tr></tr>").addClass("row-child").append($td).insertAfter($row);
      $.ajax({
        url: model_url,
      }).done(function (data) {
        $td.html(data);
        ready($td);
        if (typeof request !== "undefined") {
          request.find($td);
        }
      });
    } else {
      $row.next(".row-child").html("");
    }
    return false;
  });

  $element.find(".ajax-toggle").on("click", function (e) {
    e.preventDefault();
    let $this = $(this);
    $this.addClass("loading");

    $.ajax({
      url: $this.attr("href"),
      success: function (data) {
        $this
          .addClass("active")
          .removeClass("loading")
          .removeClass("auto-click");
      },
      error: function (jqXHR, textStatus) {
        $this.removeClass("loading");
        if (jqXHR.status !== 408) {
          alertify.notify(jqXHR.responseText);
          $(".auto-sync-btn").addClass("m");
        }
      },
    });
  });

  $element
    .find("input[form-url],textarea[form-url], select[form-url]")
    .on("change", function (event) {
      let information = {};
      let $this = $(this);

      const target = event.target;
      const name = target.getAttribute("name");
      const value = target.type !== "checkbox" ? $this.val() :  getCheckboxValue(target);

      information[name] = value;
      $this.removeClass("text-red text-green").addClass("m");
      $.ajax({
        method: "POST",
        url: $this.attr("form-url"),
        data: information,
        dataType: "json",
      })
        .fail(function () {
          $this.addClass("text-red");
        })
        .done(function (data) {
          if (data.success) {
            $this.addClass("text-green");
          } else {
            $this.addClass("text-red");
          }
        })
        .always(function (data) {
          $("#result-ajax").html(data["responseText"]);
          $this.removeClass("m");
        });
    });
  $element.find("a[update]").on("click", function (event) {
    event.preventDefault();
    let $this = $(this);
    $.ajax({
      method: "POST",
      url: $this.attr("href"),
      success: function (data) {
        let $update = $($this.attr("update"));
        $update.html(data);
        ready($update);
      },
    });
  });

  $element.find("[activate]").on("click", function (event) {
    event.preventDefault();
    let $target = $(this).attr("activate");
    console.log($target);
    $($target).toggleClass("active");
  });

  $element.find("a.ajax-hide").on("click", function (event) {
    event.preventDefault();
    let $this = $(this);
    $this.addClass("active");
    $.ajax({
      url: $this.attr("href"),
      cache: false,
      success: function (data) {
        $this.fadeOut();
      },
      error: function () {
        $this.removeClass("active");
      },
    });
  });

  $element.find(".grid-admin tr td").on("click", function () {
    $(".grid-admin tr").removeClass("aimed");
    $(this).parent("tr").addClass("aimed");
  });

  $element.find(".track-import-btn").on("mousedown", function () {
    $(this).addClass("m");
  });

	Array.from(document.querySelectorAll("[id^=toggle-password]")).forEach(element => {
		element.addEventListener("click", e => {
			const input = e.currentTarget.previousElementSibling;

			if (input) {
				if (input.type === 'password') {
					input.type = 'string';
					e.currentTarget.classList.remove("fa-eye");
					e.currentTarget.classList.add("fa-eye-slash");
				} else {
					input.type = 'password';
					e.currentTarget.classList.remove("fa-eye-slash");
					e.currentTarget.classList.add("fa-eye");
				}
			}
		});
	});

	const tables = document.querySelectorAll('table');

	for (const table of tables) {
		initTableWithScrollableCells(table);
	}

	Array.from(document.querySelectorAll('.flex-table.flex-table-test')).forEach(table => {
		initResizableTable(table);
		initTableWithToggleableColumns(table);
	});

	Array.from(document.querySelectorAll('.table-with-divider')).forEach(table => initTableWithDivider(table));

	document.querySelector(".aside-collapse-button")?.addEventListener("click", () => {
		const aside = document.querySelector(".aside");

		if (aside) {
			const isHiddenByDefault = window.matchMedia("(max-width: 1280px)").matches;
			const mainContent = document.querySelector(".layout-aside__main");

			if (isHiddenByDefault) {
				aside.classList.remove("aside_collapsed");
				if (aside.classList.contains("aside_shown")) {
					mainContent.style.paddingLeft = "0";
					aside.classList.remove("aside_shown");
				} else {
					mainContent.style.paddingLeft = aside.clientWidth + "px";
					aside.classList.add("aside_shown");
				}
			} else {
				mainContent.style.paddingLeft = "0";
				aside.classList.remove("aside_shown");
				if (aside.classList.contains("aside_collapsed")) {
					aside.classList.remove("aside_collapsed");
				} else {
					aside.classList.add("aside_collapsed");
				}
			}
		}
	});

	const asideSearch = document.querySelector(".aside-search");
	if (asideSearch) {
		asideSearch.addEventListener("input", () => {
			const searchValue = asideSearch.value.toLowerCase();

			const nav = document.querySelector(".aside-nav");

			for(const item of nav.children) {
				if (item.textContent.toLowerCase().includes(searchValue)) {
					item.classList.remove("hidden");
				} else {
					item.classList.add("hidden");
				}
			}
		});
	}
};

function getCheckboxValue(input) {
    return "checked" in input && input.checked ? "1" : "0";
}

let $autoCLick = null;
jQuery(window).ready(function () {
  let $loading = $("#infscr-loading").hide();
  $(document)
    .ajaxStart(function () {
      $loading.show();
    })
    .ajaxStop(function () {
      $loading.hide();
    });
  $(".table-popular").height($(".table-errors").height());
});

jQuery.fn.elastic = function () {
  return this.each(function () {
    this.style.height = "5px";
    this.style.height = this.scrollHeight + 2 + "px";
  });
};
